import { render, staticRenderFns } from "./TourTable.vue?vue&type=template&id=1afe22f6&scoped=true"
import script from "./TourTable.vue?vue&type=script&lang=js"
export * from "./TourTable.vue?vue&type=script&lang=js"
import style0 from "./TourTable.vue?vue&type=style&index=0&id=1afe22f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afe22f6",
  null
  
)

export default component.exports